import { render, staticRenderFns } from "./BaseSelectbox.vue?vue&type=template&id=5a6794a2&"
import script from "./BaseSelectbox.vue?vue&type=script&lang=js&"
export * from "./BaseSelectbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports